import CardComponent from "@plugins/card/components/CardComponent";
import CardList from "@plugins/card/components/CardList";

const Plugin = {
  install(app) {
    app.component("card-component", CardComponent);
    app.component("card-list", CardList);
  },
};

export default Plugin;
